module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-17.cca3e784.png";